<!-- Embargo Override Modal -->
<nz-modal
  [(nzVisible)]="showModal"
  nzTitle="{{ embargoOverrideType }} Embargo Override"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzWidth]="500"
  (nzOnCancel)="handleCancelForEmbargoOverride()"
>
  <ng-template #modalContent>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="13">Sell Side Firm</div>
      <div nz-col nzSpan="11">
        <nz-select
          nzShowSearch
          nzServerSearch
          [nzSuffixIcon]="inputClearTplSellSide"
          nzPlaceHolder="(Select a Sell Side Firm)"
          [(ngModel)]="selectedSellSideFirm"
          (keydown)="handleModelChange($event, 'broker')"
          (nzOnSearch)="searchSellSideFirm($event)"
          [nzDisabled]="embargoOverrideType === 'Edit'"
          [nzNotFoundContent]="noData"
          (nzOpenChange)="handleOpenChange($event, 'broker')"
          (nzBlur)="showHideEmptyDropDownContentEL(false)"
        >
          <nz-option
            *ngFor="let firm of sellSideFirmList"
            [nzLabel]="firm.name"
            [nzValue]="firm.id"
          ></nz-option>
        </nz-select>
        <div *ngIf="!selectedSellSideFirm && showError" class="error-msg">
          * Sell side firm is required
        </div>
      </div>
    </div>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="13">Buy Side Firm</div>
      <div nz-col nzSpan="11">
        <nz-select
          nzShowSearch
          nzServerSearch
          [nzSuffixIcon]="inputClearTplBuySide"
          nzPlaceHolder="(Select a Buy Side Firm)"
          [(ngModel)]="selectedBuySideFirm"
          (keydown)="handleModelChange($event, 'buyside')"
          (nzOnSearch)="searchBuySideFirm($event)"
          [nzDisabled]="embargoOverrideType === 'Edit'"
          [nzNotFoundContent]="noData"
          (nzOpenChange)="handleOpenChange($event, 'buyside')"
          (nzBlur)="showHideEmptyDropDownContentEL(false)"
        >
          <nz-option
            *ngFor="let firm of buySideFirmList"
            [nzLabel]="firm.name"
            [nzValue]="firm.id"
          ></nz-option>
        </nz-select>
        <div *ngIf="!selectedBuySideFirm && showError" class="error-msg">
          * Buy side firm is required
        </div>
      </div>
    </div>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="13">Model Data Usage Embargo Days</div>
      <div nz-col nzSpan="11">
        <input nz-input type="number" min="0" [(ngModel)]="modelData" />
      </div>
    </div>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="13">Model Download Embargo Days</div>
      <div nz-col nzSpan="11">
        <input nz-input type="number" min="0" [(ngModel)]="modelDownload" />
      </div>
    </div>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="13">Research Download Embargo Days</div>
      <div nz-col nzSpan="11">
        <input nz-input type="number" min="0" [(ngModel)]="researchDownload" />
        <div
          *ngIf="!modelData && !modelDownload && !researchDownload && showError"
          class="error-msg"
        >
          * At least one override is required
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #modalFooter>
    <button
      nz-button
      nzType="default"
      (click)="handleCancelForEmbargoOverride()"
    >
      Cancel
    </button>
    <button nz-button nzType="primary" (click)="handleSave()">Save</button>
  </ng-template>
</nz-modal>

<ng-template #inputClearTplSellSide>
  <i
    nz-icon
    class="ant-input-clear-icon"
    nzTheme="fill"
    nzType="close-circle"
    [ngClass]="embargoOverrideType === 'Edit' ? 'disable-icon' : ''"
    *ngIf="selectedSellSideFirm"
    (click)="clear('sellside')"
  ></i>
</ng-template>

<ng-template #inputClearTplBuySide>
  <i
    nz-icon
    class="ant-input-clear-icon"
    nzTheme="fill"
    nzType="close-circle"
    [ngClass]="embargoOverrideType === 'Edit' ? 'disable-icon' : ''"
    *ngIf="selectedBuySideFirm"
    (click)="clear('buyside')"
  ></i>
</ng-template>
<ng-template #noData>
  <div>
    No Data
  </div>
</ng-template>
